import styled from 'styled-components'
import { Row } from '@microfrontends/react-components'

export const RecommendJobsContainer = styled(Row)`
	margin-bottom: 30px;
`

export const JobsWrapper = styled.ul`
	padding: 10px 30px 20px;
	background: #eff5ff;
	border-radius: 6px;
	@media screen and (max-width: 1024px) {
		padding: 20px 12px;
	}
`

export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`
